import React from "react";
import styled from "styled-components";
import {
  Grid,
  Typography,
  Box,
  Stack,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { useSelector } from "react-redux";
import { selectSelectedSchool } from "app/modules/schools/selectors";
import dayjs from "dayjs";
import { IndianCurrency, NumberInWord } from "app/utils/helper";
import { CALENDAR_ORDER } from "app/config/constants";

const InvoiceTemplate2 = ({
  invoiceText,
  data2,
  invoiceItems2,
  keepHeaderSpace = false,
}) => {
  const selectedSchool = useSelector(selectSelectedSchool);
  const isMobile = useMediaQuery("(max-width:768px)");

  const totalAmount = data2?.totalPaidFeeAmount + data2?.totalFineAmount;

  return (
    <LeftSideDiv isMobile={isMobile}>
      <InvoiceHeader>
        {keepHeaderSpace ? (
          <Box sx={{ height: "180px" }} />
        ) : (
          <div
            style={{
              width: "100%",
            }}
          >
            <Grid container sx={{ bgcolor: "#f8f9fb", py: 1 }}>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {selectedSchool?.schoolLogo && (
                  <Box
                    sx={{
                      width: 65,
                      height: 65,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #d0d0e2",
                      borderRadius: "8px",
                      bgcolor: "#fff",
                      p: 0.25,
                    }}
                  >
                    <img
                      src={selectedSchool?.schoolLogo}
                      style={{
                        maxHeight: "100%",
                        maxWidth: "100%",
                        objectFit: "contain",
                        borderRadius: "6px",
                      }}
                      alt="school-logo"
                    />
                  </Box>
                )}
              </Grid>
              <Grid item xs={10} sx={{ pl: 1 }}>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#0C4B7E",
                    letterSpacing: "0.25px",
                  }}
                >
                  {selectedSchool?.schoolName}
                </Typography>

                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: "11px",
                    fontWeight: 500,
                    color: "#333",
                    mt: 0.5,
                  }}
                >
                  {`${selectedSchool?.schoolAddress?.address}, ${selectedSchool?.schoolAddress?.dist}, ${selectedSchool?.schoolAddress?.state}, ${selectedSchool?.schoolAddress?.pinCode}`}
                </Typography>

                <Typography
                  sx={{
                    textAlign: "center",
                    fontSize: "10px",
                    fontWeight: 500,
                    color: "#666",
                    mt: 0.3,
                  }}
                >
                  {selectedSchool?.schoolContactNumber}, {selectedSchool?.email}
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                width: "100%",
                fontWeight: 700,
                fontSize: "14px",
                letterSpacing: "1px",
                textTransform: "uppercase",
                textAlign: "center",
                color: "#fff",
                bgcolor: "#1e4976",
                py: 0.75,
                borderBottom: "3px solid #FFA726",
              }}
            >
              {invoiceText} - {`${data2?.session}`}
            </Box>
          </div>
        )}
      </InvoiceHeader>
      <InvoiceBody>
        <Grid
          container
          sx={{
            px: 1.5,
            py: 1,
            bgcolor: "#fafbfc",
            borderBottom: "1px solid #d0d0e2",
          }}
        >
          <Grid item xs={4} sx={{ borderRight: "1px solid #e8eaed", pr: 1 }}>
            <Typography
              sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
            >
              Invoice No.
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
              {data2?.invoiceNumber}
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ borderRight: "1px solid #e8eaed", px: 1 }}>
            <Typography
              sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
            >
              Collection Date
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
              {dayjs(data2?.collectionDate).format("DD MMM, YYYY")}
            </Typography>
          </Grid>
          <Grid item xs={4} sx={{ pl: 1 }}>
            <Typography
              sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
            >
              Depositor Name
            </Typography>
            <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
              {data2?.depositorName}
            </Typography>
          </Grid>
          {/* student detail */}
          <Box
            sx={{
              borderRadius: "8px",
              border: "1px solid #d0d0e2",
              bgcolor: "#f8f9fb",
              p: 1.5,
              m: 1.5,
            }}
          >
            <Grid container spacing={1.5}>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Name
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.studentName}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Father's Name
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.fatherName}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Mother's Name
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.motherName}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Class-Str-Sec
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.className_stream_sec}
                </Typography>
              </Grid>

              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Reg No
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.registrationNumber}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  SR Number
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.srNumber}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Adm No
                </Typography>
                <Typography sx={{ fontWeight: 700, fontSize: "11px" }}>
                  {data2?.studentDetail?.admissionNumber}
                </Typography>
              </Grid>
              <Grid item xs={3}>
                <Typography
                  sx={{ fontWeight: 600, fontSize: "10px", color: "#666" }}
                >
                  Transport Info
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "11px",
                    wordWrap: "breakWord",
                    overflowWrap: "breakWord",
                    whiteSpace: "normal",
                  }}
                >
                  {data2?.transportInfo?.vehicleNumber
                    ? `${data2?.transportInfo?.vehicleNumber}: ${data2?.transportInfo?.to}`
                    : "--"}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Grid>

        <Box
          sx={{
            bgcolor: "#FFA726",
            py: 1,
            px: 1.5,
            borderTop: "1px solid #e0e0e0",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Grid container columns={25} spacing={2}>
            <Grid item xs={5}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Fee Type
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Fee Amount
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Discount
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Prev. Paid
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Paying Fee
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                  wordWrap: "breakWord",
                  overflowWrap: "breakWord",
                }}
              >
                Balance
              </Typography>
            </Grid>
          </Grid>
        </Box>
        {invoiceItems2?.map((invoice, i) => {
          const formatMonthList = (monthList) => {
            const sortedMonthList = monthList.sort((a, b) => {
              const [monthA, yearA] = a.split("-");
              const [monthB, yearB] = b.split("-");

              const monthIndexA = CALENDAR_ORDER.indexOf(monthA);
              const monthIndexB = CALENDAR_ORDER.indexOf(monthB);

              if (yearA === yearB) {
                return monthIndexA - monthIndexB;
              }

              return yearA - yearB || monthIndexA - monthIndexB;
            });

            return sortedMonthList
              .map(
                (item, i) =>
                  `${item}${i < sortedMonthList.length - 1 ? ", " : ""}`
              )
              .join(" ");
          };

          const monthList =
            invoice?.monthYearList && formatMonthList(invoice.monthYearList);
          return (
            <Box key={i}>
              <Grid container sx={{ px: 1 }} columns={25} spacing={1}>
                <Grid item xs={5}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    {invoice?.feeType}
                    {/* ({invoice?.feeCode}) */}
                  </Typography>
                  <Stack direction={"row"} gap={0.5}>
                    <Typography
                      sx={{
                        fontSize: "10px",
                        fontWeight: 500,
                        wordWrap: "breakWord",
                        overflowWrap: "breakWord",
                      }}
                    >
                      ({monthList})
                    </Typography>
                  </Stack>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: 500,
                      wordWrap: "breakWord",
                      overflowWrap: "breakWord",
                    }}
                  >
                    {IndianCurrency(invoice?.t_feeAmount)}
                    {/* +
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        {IndianCurrency(invoice?.t_fineAmount)}
                      </span> */}
                  </Typography>
                </Grid>

                {/* Discount */}
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: 500,
                      wordWrap: "breakWord",
                      overflowWrap: "breakWord",
                    }}
                  >
                    {IndianCurrency(
                      invoice?.t_recurringDiscountAmount +
                        invoice?.givenExtraDiscount +
                        Number(invoice?.limitedPeriodDiscountAmount ?? 0)
                    )}
                    +
                    <span
                      style={{
                        color: "green",
                      }}
                    >
                      {IndianCurrency(invoice?.givingExtraDiscount)}
                    </span>
                    {/* +
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        {IndianCurrency(invoice?.preWaivedFine)}
                      </span> */}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: 500,
                      wordWrap: "breakWord",
                      overflowWrap: "breakWord",
                    }}
                  >
                    {IndianCurrency(invoice?.prePaidFee)}
                    {/* +
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        {IndianCurrency(invoice?.prePaidFine)}
                      </span> */}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: 500,
                      wordWrap: "breakWord",
                      overflowWrap: "breakWord",
                    }}
                  >
                    {IndianCurrency(invoice?.payingFee)}
                    {/* +
                      <span
                        style={{
                          color: "red",
                        }}
                      >
                        {IndianCurrency(invoice?.payingFine)}
                      </span> */}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: 500,
                      wordWrap: "breakWord",
                      overflowWrap: "breakWord",
                    }}
                  >
                    {IndianCurrency(invoice?.balanceAmount ?? 0)}
                  </Typography>
                </Grid>
              </Grid>
              {invoiceItems2?.length !== i + 1 && (
                <Divider
                  sx={{ background: (theme) => theme.palette.primary.main }}
                />
              )}
            </Box>
          );
        })}
        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />
        <Grid container sx={{ px: 1 }} spacing={1} columns={25}>
          {/* <Grid item xs={2}>
              <Typography sx={{ fontSize: "10px", fontWeight: 500 }}>
                Pre Dues
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                --
              </Typography>
            </Grid> */}
          <Grid item xs={5}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}></Typography>
          </Grid>

          {/* Total Fee Amount */}
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(data2?.totalFeeAmount ?? 0)}
              {/* +{" "}
                <span
                  style={{
                    color: "red",
                  }}
                >
                  {IndianCurrency(data2?.TotalFineAmount ?? 0)}
                </span> */}
            </Typography>
          </Grid>

          {/* Total Discount */}
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(
                (data2?.totalRecurringDiscountAmount ?? 0) +
                  (data2?.totalGivenExtraDiscount ?? 0) +
                  Number(data2?.t_limitedPeriodDiscountAmount ?? 0)
              )}{" "}
              +{" "}
              <span
                style={{
                  color: "green",
                }}
              >
                {IndianCurrency(data2?.totalGivingExtraDiscount ?? 0)}
              </span>
              {/* +{" "}
                <span
                  style={{
                    color: "red",
                  }}
                >
                  {IndianCurrency(data2?.PreWaivedFine ?? 0)}
                </span> */}
            </Typography>
          </Grid>

          {/* Previous Paid */}
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(data2?.totalPrePaidFee ?? 0)}
              {/* +{" "}
                <span
                  style={{
                    color: "red",
                  }}
                >
                  {IndianCurrency(data2?.totalPrePaidFine ?? 0)}
                </span> */}
            </Typography>
          </Grid>

          {/*Total Paying Fee */}
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(data2?.totalPayingFee ?? 0)}
              {/*                 
                +{" "}
                <span
                  style={{
                    color: "red",
                  }}
                >
                  {IndianCurrency(data2?.totalPayingFine ?? 0)}
                </span> */}
            </Typography>
          </Grid>

          {/* Total Balance */}
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(data2?.totalBalanceAmount ?? 0)}
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />
        <Grid container sx={{ px: 1 }}>
          <Grid item xs={12}>
            {/* <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                Current Discount Amount:{data2?.totalGivingExtraDiscount ?? 0}
              </Typography> */}
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            >
              Discount Remarks:{data2?.givingDiscountRemarksList ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            ></Typography>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            ></Typography>
          </Grid>
        </Grid>
        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />
        <Grid container sx={{ px: 1 }}>
          <Grid item xs={12}>
            {/* <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                Current Discount Amount:{data2?.totalGivingExtraDiscount ?? 0}
              </Typography> */}
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            >
              Total Fine Amount:{data2?.totalPayingFine ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            ></Typography>
            <Typography
              sx={{
                fontSize: "10px",
                fontWeight: 600,
              }}
            ></Typography>
          </Grid>
        </Grid>
        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />
        {/* <Grid container sx={{ px: 1 }}>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                Grand Total
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                {IndianCurrency(calculateGrandTotal())}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                Paying Fee + Fine
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                {data?.totalPaidFeeAmount} +{" "}
                <span style={{ color: "red" }}>{data?.totalFineAmount}</span>
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                Balance
              </Typography>
              <Typography
                sx={{
                  fontSize: "10px",
                  fontWeight: 600,
                }}
              >
                {data?.totalBalanceFeeAmount}
              </Typography>
            </Grid>
          </Grid> */}
        {/* <Divider sx={{ background: (theme) => theme.palette.primary.main }} /> */}
        <Grid container sx={{ px: 1 }}>
          <Grid item xs={9}>
            <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
              Paid Amount :{" "}
              {NumberInWord(
                totalAmount
                // + (data2?.totalPayingFine ?? 0)
              )}{" "}
              {/* {NumberInWord(calculateGrandTotal() + calculateTotalFine())}{" "} */}
              Rupees Only
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
              {IndianCurrency(
                totalAmount ?? 0
                // + (data2?.totalPayingFine ?? 0)
              )}
            </Typography>
          </Grid>
        </Grid>
        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />

        <Grid container sx={{ px: 1 }}>
          <Grid item xs={4}>
            <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
              Payment Mode :{" "}
              {data2?.paymentDetails
                ? Object.keys(data2?.paymentDetails)[0]
                : "--"}
            </Typography>
          </Grid>
          {data2?.paymentDetails?.UpiMode && (
            <Grid item xs={8}>
              <Stack direction={"row"} justifyContent={"space-around"}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  UPI Number: {data2?.paymentDetails?.UpiMode?.upiNumber}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Transaction ID:{" "}
                  {data2?.paymentDetails?.UpiMode?.transactionId}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Amount: {data2?.paymentDetails?.UpiMode?.amount}
                </Typography>
              </Stack>
            </Grid>
          )}
          {data2?.paymentDetails?.CardMode && (
            <Grid item xs={8}>
              <Stack direction={"row"} justifyContent={"space-around"}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Card Holder Name:{" "}
                  {data2?.paymentDetails?.CardMode?.cardHolderName}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Card Number: {data2?.paymentDetails?.CardMode?.cardNumber}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Amount: {data2?.paymentDetails?.CardMode?.amount}
                </Typography>
              </Stack>
            </Grid>
          )}
          {data2?.paymentDetails?.ChequeMode && (
            <Grid item xs={8}>
              <Stack direction={"row"} justifyContent={"space-around"}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Cheque No.: {data2?.paymentDetails?.ChequeMode?.chequeNumber}
                </Typography>

                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Amount: {data2?.paymentDetails?.ChequeMode?.amount}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Deposition Date:{" "}
                  {dayjs(
                    data2?.paymentDetails?.ChequeMode?.depositionDate
                  ).format("DD MMM YYYY")}
                </Typography>
              </Stack>
            </Grid>
          )}
          {data2?.paymentDetails?.NEFTMode && (
            <Grid item xs={8}>
              <Stack direction={"row"} justifyContent={"space-around"}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Reference No.:{" "}
                  {data2?.paymentDetails?.NEFTMode?.referenceNumber}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Amount: {data2?.paymentDetails?.NEFTMode?.amount}
                </Typography>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Transaction No.:{" "}
                  {data2?.paymentDetails?.NEFTMode?.transactionNumber}
                </Typography>
              </Stack>
            </Grid>
          )}
          {data2?.paymentDetails?.CashMode && (
            <Grid item xs={8}>
              <Stack direction={"row"} justifyContent={"space-around"}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Amount: {data2?.paymentDetails?.CashMode?.amount}
                </Typography>
              </Stack>
            </Grid>
          )}
        </Grid>

        {data2?.status === "DELETED" && (
          <>
            <Divider
              sx={{ background: (theme) => theme.palette.primary.main }}
            />

            <Grid container sx={{ px: 1 }}>
              <Grid item xs={2}>
                <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                  Status :{" "}
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    {data2?.status ?? "--"}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={4}>
                <Typography sx={{ fontSize: "12px", fontWeight: 600 }}>
                  At :{" "}
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    {data2?.updatedOn
                      ? dayjs(data2?.updatedOn).format("DD MMM YYYY h:mm A")
                      : "--"}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Stack direction={"row"} justifyContent={"space-around"}>
                  <Typography sx={{ fontSize: "10px", fontWeight: 600 }}>
                    Deletion Remarks : {data2?.deletionRemarks ?? "--"}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>
          </>
        )}

        <Divider sx={{ background: (theme) => theme.palette.primary.main }} />
        <Stack direction="row" justifyContent="space-between" sx={{ px: 1 }}>
          <Box>
            <Typography sx={{ fontSize: "10px" }}>
              Created By : {data2?.createdBy?.personName}
            </Typography>
            <Typography sx={{ fontSize: "10px" }}>
              Created On :{" "}
              {dayjs(data2?.createdOn).format("DD MMM YYYY h:mm A")}
            </Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: "10px" }}>For,</Typography>
            <Typography sx={{ fontSize: "10px" }}>
              {data2?.schoolName}
            </Typography>
            <Typography sx={{ fontSize: "10px", pt: 2, pb: 1 }}>
              Authorised Sign.
            </Typography>
          </Box>
        </Stack>
      </InvoiceBody>
    </LeftSideDiv>
  );
};

export default InvoiceTemplate2;

const LeftSideDiv = styled.div`
  margin: 5px;
  width: 100%;
  height: 100%;
  border: 1px solid black;
  background-color: #fff;
  margin-bottom: ${(props) => (props.isMobile ? "100px" : "0")};
`;

const InvoiceHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const InvoiceBody = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;
